<template>
  <Modal
    ref="bulkUpdateCategoriesModalRef"
    class="categories-modal"
    withCloser
    :showIcon="false"
    :modalStyle="{ maxWidth: 'calc(100vw - 32px)', width: '1328px', minHeight: '670px' }"
  >
    <template v-slot:body>
      <div class="categories-modal-context">
        <h2 class="categories-modal-title">Toplu ürün şablonu oluşturun</h2>
        <p class="categories-modal-desc">Öncelikle şablon oluşturmak istediğiniz kategoriyi aratarak ya da seçerek şablonu bilgisayarınıza indirin.</p>
        <div class="categories-modal-content"  style="min-height: 540px;">
          <h3>Hangi kategoride şablon oluşturmak istiyorsunuz?</h3>
          <div class="categories-modal-content-search-field" ref="searchFieldContainer">
            <SearchField
              @searchValue="handleSearchInput"
              :placeholderText="'Kategori Ara'"
              style="max-width: 640px;"
            />
            <ul class="search-field-result-box" v-show="showOptions" v-if="searchText && filteredCategories.length > 0">
              <li
                class="search-field-result-box-item"
                v-for="item in filteredCategories"
                :key="item.id"
              >
                <div class="item-details">
                  <span v-html="formatCategoryPath(item.value)"></span>
                </div>
                <AppButton @click="fetchProductTemplates(item)" :class="{ 'active-button': downloadedItemIds[item.id], 'hover-button': true }" style="max-width: fit-content; height: 24px !important" secondary xsm title="İndir">
                  <template #prependIcon>
                    <Icons name="Download" color="#1C1C1E" :class="['download-icon', 'hover-icon', {'icon-active': downloadedItemIds[item.id] }]" />
                  </template>
                </AppButton>
              </li>
            </ul>
          </div>
          <div v-if="!selectedCategory" class="group-categories">
            <div v-for="item in groupCategories" :key="item.id">
              <div class="group-categories-item" @click="selectCategory(item)">
                <img :src="item.imageUrl?.replace('/{}/', '/104_104/')" alt="">
                <span>{{ item.groupName }}</span>
              </div>
            </div>
          </div>

          <div v-else class="category-tree">
            <div class="category-tree-column">
              <div class="category-tree-item group-name">Ana Kategoriler</div>
              <ul>
                <li v-for="item in groupCategories" :key="item.id">
                  <div class="category-tree-item parent" :class="{ selected: item.groupName === selectedCategory.groupName }" @click="selectCategory(item)">
                    <div>
                      <img class="category-tree-item-image" :src="item.imageUrl?.replace('/{}/', '/104_104/')" alt="">
                      <span>{{ item.groupName }}</span>
                    </div>
                    <Icons name="RightArrows" color="#7382A0"/>
                  </div>
                </li>
              </ul>
            </div>
            <div v-for="(column, colIndex) in columns" :key="colIndex" class="category-column">
              <div class="category-tree-item group-name">{{ categoryPath[colIndex]  }}</div>
              <ul>
                <li v-for="item in column" :key="item.id">
                  <div class="category-tree-item" :class="{ selected: categoryPath.includes(item.name) }" @click="fetchChildCategoriesByParentId(item.id)">
                    <span>{{ item.name }}</span>
                    <div class="category-tree-item-leaf">
                      <Icons name="RightArrows" color="#7382A0" v-if="!item.isLeaf"/>
                      <AppButton @click="fetchProductTemplates(item)" v-else  :class="{ 'active-button': downloadedItemIds[item.id], 'hover-button': true }" style="max-width: fit-content; height: 24px !important" secondary xsm title="İndir">
                        <template #prependIcon>
                          <Icons name="Download" color="#1C1C1E" :class="['download-icon', 'hover-icon', {'icon-active': downloadedItemIds[item.id] }]" />
                        </template>
                      </AppButton>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Modal>
  <div class="flex-container">
    <PageTop title="Toplu Ürün Yönetimi" />
    <div class="main-area">
      <div class="filter-area-top header-tab">
        <div class="periods">
          <div v-for="(tab) in headerTabs"
            :class="['tab', { 'selected': tab.key === selectedHeaderTabIndex }]"
            @click="clickPeriodBtn(tab.key)">
            {{ tab.tabName }}
          </div>
        </div>
        <a v-if="educationalVideoUrl" :href="educationalVideoUrl" class="watch-link" target="_blank">
          <img src="@/assets/images/icons/icon-play.svg" />
          Eğitim Videosunu İzle
        </a>
      </div>

      <hr class="seperator" />
      <div class="info-box-wrapper">
        <div class="info-box" v-if="infoBoxVisible && hasShipmentTemplate && selectedHeaderTabIndex === HEADER_TAB_UPLOAD">
          <img width="20px" height="20px" src="@/assets/images/icons/info-circle.svg" />
          <div class="info-box-container">
            <div>
              <span>Teslimat şablonunuz var.</span>
              <p>Teslimat şablonunuz olduğu için toplu ürün ekleme işlemine başlayabilir veya yeni teslimat şablonu oluşturabilirsiniz.</p>
            </div>

            <div class="btn-container">
              <AppButton secondary sm @click="goToAddNewProduct()" title="Yeni Teslimat Şablonu Oluştur" style="max-width: 234px;"/>
              <a href="#" class="dismiss-info-box" @click="dismissInfoBox()">&times;</a>
            </div>
          </div>
        </div>
      </div>
      <div class="template-manager" v-if="!loading">
        <BulkTemplateManager
          :tab="selectedHeaderTabIndex"
          :key="selectedHeaderTabIndex"
          :action="action"
          :index="index"
          v-for="(action, index) in bulkTemplateActions[selectedHeaderTabIndex]"
          @refreshTable="refreshTable"
        />
      </div>
      <div class="list-area box">
        <div class="filter-area-top">
          <div class="periods">
            <div
              v-for="(tab) in tableTabs"
              :class="['tab table-tabs', { 'selected': tab.key === selectedTabIndex, 'disabled': isTabDisabled(tab.key) }]"
              @click="!isTabDisabled(tab.key) && changeTab(tab.key)"
            >
              {{ tab.tabName }}
            </div>
          </div>
        </div>

        <div class="table-area">
          <TableForBulk
            ref="bulkTable"
            :selectedTabIndex="selectedTabIndex"
            :selectedHeaderTabIndex="selectedHeaderTabIndex"
            :refreshRef="refreshRef"
            @tableStatus="tableIsLoading"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  computed,
  onMounted,
  onBeforeUnmount,
  watch,
} from "vue";
import { useStore } from "vuex";
import PageTop from "@/components/Page/PageTop.vue";
import TableForBulk from "./partials/TableForBulk.vue";
import BulkTemplateManager from "@/components/BulkTemplateManager/BulkTemplateManager";
import { AppButton, Modal, SearchField, Icons } from "@n11/so-ui-components";
import { ToastMessageTypes } from "@/utils/enum/toastMessageTypes";
import {
  BULK_UPLOAD_CREATE_TEXTS,
  BULK_UPLOAD_DOWNLOAD_TEXTS,
  BULK_UPLOAD_UPLOAD_TEXTS,
  BULK_UPDATE_DOWNLOAD_TEXTS,
  BULK_UPDATE_UPLOAD_TEXTS,
  BULK_DELETE_DOWNLOAD_TEXTS,
  BULK_DELETE_UPLOAD_TEXTS,
  BULK_ACTIONS
} from "@/utils/enum/bulkActions";
import {
  HISTORY_TAB_DOWNLOAD,
  HISTORY_TAB_UPLOAD,
  HEADER_TAB_UPLOAD,
  HEADER_TAB_UPDATE,
  HEADER_TAB_DELETE,
} from "@/utils/enum/bulkActionTabs";

const store = useStore();
const loading = ref(true);
const refreshRef = ref({});
const headerTabs = [
  { key: HEADER_TAB_UPLOAD, tabName: 'Toplu Ürün Ekle'},
  { key: HEADER_TAB_UPDATE, tabName: 'Ürünleri Güncelle' },
  { key: HEADER_TAB_DELETE, tabName: 'Ürünleri Sil' },
];
const tableTabs = [
  { key: HISTORY_TAB_DOWNLOAD, tabName: "Şablon İndirme Geçmişim" },
  { key: HISTORY_TAB_UPLOAD, tabName: "Dosya Yükleme Geçmişim" },
];
const selectedHeaderTabIndex = ref(HEADER_TAB_UPLOAD);
const selectedTabIndex = ref(HISTORY_TAB_UPLOAD);
const shipmentTemplates = ref(null);
const hierarchCategories = ref([]);
const groupCategories = ref([]);
const categoryPath = ref([]);
const selectedCategory = ref(null);
const filteredCategories = ref([]);
const searchText = ref('');
const columns = ref([]);
const bulkUpdateCategoriesModalRef = ref();
const searchFieldContainer = ref();
const downloadedItemIds = ref({});
const tableIsLoadingRef = ref(true);
const showOptions = ref(false);

const INITIALEDUCATIONALURL = 'https://magazadestek.n11.com/egitim-detay/excel-ile-toplu-urun-nasil-yuklenir-20890'
const educationalVideoUrl = ref(INITIALEDUCATIONALURL)

const urls = {
  CREATE: 'https://magazadestek.n11.com/egitim-detay/excel-ile-toplu-urun-nasil-yuklenir-20890',
  DELETE: 'https://magazadestek.n11.com/egitim-detay/n11-magazasinda-toplu-urun-silme-21870',
  UPDATE: 'https://magazadestek.n11.com/egitim-detay/excel-ile-toplu-urun-guncelleme-22231'
};

const refreshTable = (e) => {
  selectedTabIndex.value = e.tab;
  refreshRef.value = e;
  selectedHeaderTabIndex.value = e.headerTab;
};

const tableIsLoading = (e) => {
  tableIsLoadingRef.value = e.isLoading;
};

const isTabDisabled = (tabKey) => {
  return selectedHeaderTabIndex.value === HEADER_TAB_UPLOAD && tabKey === HISTORY_TAB_DOWNLOAD || tableIsLoadingRef.value;
};

const goToAddNewProduct = () => {
  window.open('/selleroffice/product/shippingInformationList', '_blank');
};

const dismissInfoBox = () => {
  infoBoxVisible.value = false;
};

const bulkTemplateActions = reactive({
  [HEADER_TAB_UPLOAD]: [
    {
      ...BULK_UPLOAD_CREATE_TEXTS,
      ctaAction: () => goToAddNewProduct(),
      errors: {}
    },
    {
      ...BULK_UPLOAD_DOWNLOAD_TEXTS,
      ctaAction: () => openTemplateCreateModal(),
      errors: {}
    },
    {
      ...BULK_UPLOAD_UPLOAD_TEXTS,
      ctaAction: (child) => child.fileInput.value.click(),
      errors: {}
    },
  ],
  [HEADER_TAB_UPDATE]: [
    {
      ...BULK_UPDATE_DOWNLOAD_TEXTS,
      ctaAction: (c) => updateTabHandler(c),
      errors: {}
    },
    {
      ...BULK_UPDATE_UPLOAD_TEXTS,
      ctaAction: (child) => child.fileInput.value.click(),
      errors: {}
    },
  ],
  [HEADER_TAB_DELETE]: [
    {
      ...BULK_DELETE_DOWNLOAD_TEXTS,
      ctaAction: () => deleteBulkTemplate(),
      errors: {}
    },
    {
      ...BULK_DELETE_UPLOAD_TEXTS,
      ctaAction: (child) => child.fileInput.value.click(),
      errors: {}
    },
  ],
});
const changeTab = (key) => {
  if (selectedTabIndex.value !== key && !tableIsLoadingRef.value) {
    selectedTabIndex.value = key
    refreshRef.value = {
      tab: key,
      refresh: true,
      headerTab: selectedHeaderTabIndex.value
    };
  }
};
const fetchHierarchCategories = async () => {
  hierarchCategories.value = await store.dispatch(
    "categories/getHierarchyCategories"
  );
  filteredCategories.value = hierarchCategories.value;
};
const fetchGroupCategories = async () => {
  groupCategories.value = await store.dispatch("categories/getGroupCategories");
};
const deleteBulkTemplate = async () => {
  const response = await store.dispatch("templates/getDeleteBulkTemplate");
  store.commit("common/SET_TOASTER_DATA", {
    type: response.data.success
      ? ToastMessageTypes.SUCCESS
      : ToastMessageTypes.ERROR,
    description: response.data.message,
  });

    refreshTable({
      ...refreshRef.value,
      tab: HISTORY_TAB_DOWNLOAD,
      refresh: true
    });
};
const fetchChildCategoriesByGroupName = async (groupName) => {
  try {
    const newChildCategories = await store.dispatch(
      "categories/getChildByGroupName",
      groupName
    );
    columns.value = [newChildCategories];
  } catch (error) {
    console.error("Error fetching child categories:", error);
  }
};
const selectCategory = (category) => {
  selectedCategory.value = category;
  categoryPath.value = [category.groupName];
  columns.value = [[]];
  fetchChildCategoriesByGroupName(category.categoryGroup);
};
const fetchChildCategoriesByParentId = async (parentId) => {
  try {
    const newChildCategories = await store.dispatch(
      "categories/getChildByParentId",
      parentId
    );
    if (newChildCategories.length > 0) {
      const existingIndex = columns.value.findIndex(column => column.some(item => item.id === parentId));
      if (existingIndex >= 0) {
        columns.value = columns.value.slice(0, existingIndex + 1);
        categoryPath.value = categoryPath.value.slice(0, existingIndex + 1);
      }
      const selectedItem = columns.value.flat().find(item => item.id === parentId);
      if (selectedItem) {
        categoryPath.value.push(selectedItem.name);
      }
      columns.value.push(newChildCategories);
    }
  } catch (error) {
    console.log("Error fetching child categories:", error);
  }
};
const formatCategoryPath = (categoryPath) => {
  const segments = categoryPath.split(' > ');
  const lastSegment = segments.pop();
  const precedingPath = segments.join(' > ');

  return `${precedingPath} > <strong style='font-weight: bolder'>${lastSegment}</strong>`;
};
const hasShipmentTemplate = computed(() => shipmentTemplates.value && shipmentTemplates.value.length > 0);

const clickPeriodBtn = (key) => {
  if (selectedHeaderTabIndex.value !== key && !tableIsLoadingRef.value) {
    selectedHeaderTabIndex.value = key;
    selectedTabIndex.value = key === HEADER_TAB_UPLOAD ? HISTORY_TAB_UPLOAD : HISTORY_TAB_DOWNLOAD;
    refreshRef.value = {
      headerTab: key,
      refresh: true,
      tab: selectedHeaderTabIndex.value === HEADER_TAB_UPLOAD ? HISTORY_TAB_UPLOAD : HISTORY_TAB_DOWNLOAD
    };
  }
};

const fetchProductTemplates = async (item) => {
  if (downloadedItemIds.value[item.id]) return;
  downloadedItemIds.value[item.id] = true;

  try {
    const { data } = await store.dispatch(
      "products/downloadProductTemplate",
      item.id
    );
    const { fileContent, fileName } = data;

    const binaryString = window.atob(fileContent);
    const bytes = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const blob = new Blob([bytes], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    Object.assign(link, {
      href: url,
      download: `${fileName}.xlsx`,
      style: 'display: none;',
    });

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);

  } catch (error) {
    console.error(error);
    downloadedItemIds.value[item.id] = false;
    throw new Error('Şablon dosyası indirilirken bir hata oluştu');
  }
  finally {
    downloadedItemIds.value[item.id] = false;
  }
};

const updateBulkTemplateActions = () => {
  if (hasShipmentTemplate.value) {
    bulkTemplateActions[selectedHeaderTabIndex.value] = bulkTemplateActions[
      selectedHeaderTabIndex.value
    ].filter((item) => item.type !== 'CREATE');
  }

  bulkTemplateActions[selectedHeaderTabIndex.value].forEach((action) => {
    action.hasShipmentTemplate = hasShipmentTemplate.value;
  });

};

watch(selectedHeaderTabIndex, (newValue) => {
  const url = urls[newValue];
  if (url) {
    educationalVideoUrl.value = url;
  } else {
    educationalVideoUrl.value = null;
  }
});

watch(
  () => selectedHeaderTabIndex.value,
  (newValue) => {
    if (newValue === HEADER_TAB_UPLOAD) {
      updateBulkTemplateActions();
    }
  }
);

const checkShipmentTemplateEligibility = async () => {
  try {
    const res = await store.dispatch("templates/getShipmentTemplates");
    shipmentTemplates.value = res.data?.shipmentTemplates;
    updateBulkTemplateActions();
    loading.value = false;
  } catch (error) {
    console.error("Error checking shipment template eligibility:", error);
  }
};

const handleSearchInput = (text) => {
  searchText.value = text;
  filteredCategories.value = hierarchCategories.value.filter((category) =>
    category.name.toLowerCase().includes(text.toLowerCase())
  );
  showOptions.value = true;
};

const openTemplateCreateModal = () => {
  bulkUpdateCategoriesModalRef.value?.openModal();
};

const updateTabHandler = async (t) => {
  const templateType = t?.templateType?.value.selectedRadioItem;
  const templateProductGroup = Array.isArray(t?.templateProductGroup.value)
    ? t?.templateProductGroup.value
    : t?.templateProductGroup.value.selectedItems;
  let templateTypeError = null;
  let templateProductGroupError = null;

  if (!templateType) {
    templateTypeError = 'Şablon Türü seçiniz.'

    store.commit("common/SET_TOASTER_DATA", {
      type: ToastMessageTypes.ERROR,
      description: 'Şablon türü seçmelisiniz!'
    });
  }

  if (templateProductGroup?.length === 0 &&
      (templateType?.id !== 'product-safety-update' &&
      templateType?.id !== 'product-nutritional-update' &&
      templateType?.id !== 'product-safety-info-update')) {
    templateProductGroupError = 'Ürün Grubu seçiniz.'

    const safetyTemplateTypes = [
      'product-nutritional-update',
      'product-safety-update',
      'product-safety-info-update'
    ];

    setTimeout(() => {
      const isSafetyTemplateTypes = safetyTemplateTypes.includes(templateType?.id);

      if (!isSafetyTemplateTypes && templateProductGroup?.length === 0) {
        store.commit("common/SET_TOASTER_DATA", {
          type: ToastMessageTypes.ERROR,
          description: 'Ürün grubu seçmelisiniz!'
        });
      } else if (isSafetyTemplateTypes) {
        store.commit("common/SET_TOASTER_DATA", {
          type: ToastMessageTypes.SUCCESS,
          description: response.data.message,
        });
      }
    }, 10);
  }

  bulkTemplateActions[selectedHeaderTabIndex.value].forEach((bulkTemplateAction) => {
    if (bulkTemplateAction.type === BULK_ACTIONS.DOWNLOAD) {
      bulkTemplateAction.errors = {
        templateTypeError,
        templateProductGroupError
      };
    }
  });

  if (templateTypeError || templateProductGroupError) {
    return false;
  }

  if (templateType) {
    const response = await store.dispatch("templates/getBulkUpdateTemplates", {
      type: templateType.id.toUpperCase(),
      params: {
        productStatusList: templateProductGroup.map((i) => i.id).join(',')
      }
    });

    store.commit("common/SET_TOASTER_DATA", {
      type: response.data.success
        ? ToastMessageTypes.SUCCESS
        : ToastMessageTypes.ERROR,
      description: response.data.message,
    });

    refreshTable({
      ...refreshRef.value,
      tab: HISTORY_TAB_DOWNLOAD,
      refresh: true
    });
  }
};

const handleClickOutside = () => {
  showOptions.value = false;
};

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
}),

onMounted(async () => {
  document.addEventListener('click', handleClickOutside);

  const urlParams = new URLSearchParams(window.location.search);
  const excelReport = urlParams.get('excelReport');

  if (excelReport) {
    selectedHeaderTabIndex.value = HEADER_TAB_UPDATE;
    selectedTabIndex.value = HISTORY_TAB_DOWNLOAD;

    urlParams.delete('excelReport');

    const newUrl = urlParams.toString()
      ? `${window.location.pathname}?${urlParams.toString()}`
      : window.location.pathname;
    window.history.replaceState({}, '', newUrl);
  }
  await checkShipmentTemplateEligibility();
  await fetchHierarchCategories();
  await fetchGroupCategories();

  loading.value = false;
});
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/utilities.scss';

.flex-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
  margin-bottom: 24px;

  .loading {
    aspect-ratio: 1183/518;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .seperator {
    margin: 16px 0;
    height: 0.5px;
    width: 100%;
    background-color: $colorD30;
  }

  .main-area {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: white;
    padding-bottom: 24px;
  }

  .filter-area-top {
    gap: 16px;
    display: flex;
    justify-content: space-between;
    background: $colorN00;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    &.header-tab {
      padding: 24px 24px 0px;
    }
    .watch-link {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 42px;
      border-radius: 6px;
      padding: 12px 24px;
      font-size: 14px;
      font-weight: 600;
      line-height: 18px;
      letter-spacing: -0.05px;
      color: $colorN80;
      border: 0.5px solid #B3BBCB;
      background: $colorN00;

      img {
        margin-right: 4px;
      }
    }
    .periods {
      display: flex;
      gap: 12px;

      .tab {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 166px;
        height: 42px;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 600;
        line-height: 18px;
        letter-spacing: -0.05px;
        border: 0.5px solid $colorD30;

        &.table-tabs {
          width: 190px;
          padding: 0 12px;
          font-size: 13px;
        }
        &.selected {
          font-weight: 700;
          color: $colorM50;
          background: $colorM05;
          border: 2px solid $colorM50;
        }
      }
    }
  }

  .list-area {
    border-radius: 8px;
    padding: 0 24px;
  }
}

.tab.disabled {
  border: none;
  background-color: #b3bbcb;
  color: #f5f5f5;
  cursor: not-allowed;
  pointer-events: none;
}

.info-box-wrapper {
  padding: 0 24px;
  .info-box {
    display: flex;
    background-color: $colorB10;
    padding: 16px;
    margin-bottom: 16px;
    gap: 12px;
    border-radius: 6px;

    &-container {
      display: flex;
      width: 100%;
      font-size: 13px;
      justify-content: space-between;

      span {
        font-weight: 700;
      }
      p {
        margin-top: 4px;
      }
    }

    .btn-container {
      display: flex;
      gap: 24px;
    }

    .dismiss-info-box {
      padding: 4px;
      color: #8AADD7;
      font-size: 24px;
      width: 32px;
      text-align: center;
    }
  }
}

.template-manager {
  display: flex;
  gap: 24px;
  padding: 18px 24px 24px;
}

.box {
  background: $colorN00;
  width: 100%;
}

.categories-modal {
  .category-tree {
    max-height: 400px;
    overflow: hidden;
    display: flex;
    margin-top: 24px;
    border-radius: 6px;
    > div {
      background-color: white;
      border: 1px solid $colorD30;
      width: 249px;
      overflow-y: scroll;

      &:first-child {
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
      }

      &:last-child {
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
      }
      &:not(:first-child) {
        border-left: none;
      }
    }

    &-item {
      display: flex;
      font-size: 12px;
      font-style: normal;
      line-height: 16px;
      font-weight: 400;
      padding: 6px 12px;
      border-top: 1px solid $colorD30;
      align-items: center;
      height: 40px;
      justify-content: space-between;
      text-align: left;
      cursor: pointer;
      transition: all 0.2s ease;
      
      span {
        flex: 1;
        min-width: 0;
      }
      
      &:hover {
        background-color: $colorM05;
        
        span {
          color: $colorM50;
          font-weight: 700;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        
        svg {
          color: $colorM50 !important;
        }
      }
      
      &-leaf {
        svg {
          width: 18px;
          height: 18px;
        }
      }

      &.selected {
        background-color: $colorM05;
        color: $colorM50 !important;
        font-weight: 700;
        div {
          color: $colorM50 !important;
          svg {
            color: $colorM50 !important;
          }
        }
        .category-tree-item-leaf {
          div {
            color: $colorM50 !important;
            svg {
              color: black !important;
            }
          }
        }
      }
      &.parent {
        font-weight: bold;
        svg {
          color:$colorD40;
        }
        div {
          display: flex;
          align-items: center;
          gap: 8px;
        }
      }
      &-image {
        width: 28px;
        height: 28px;
      }

      &.group-name {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        padding: 10px 12px;
        border-top: none;
        line-height: 20px;
        position: sticky;
        top: 0;
        background-color: $colorN00;
        z-index: 1;
        border-bottom: 1px solid $colorD30;
      }
    }
  }
  .group-categories {
    display: flex;
    gap: 12px;
    margin-top: 24px;
    > div {
      &:first-child {
        display: none;
      }
    }
    &-item {
      padding: 12px;
      min-height: 172px;
      background-color: $colorN00;
      border-radius: 6px;
      border: 2px solid transparent;
      display: flex;
      flex-direction: column;
      gap: 8px;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        border-color: $colorM50;

        span {
          color: $colorM50;
        }
      }

      span {
        font-size: 13px;
        font-style: normal;
        font-weight: 600;
        line-height: 18px;
        transition: color 0.2s ease;
      }

      img {
        width: 104px;
        height: 104px;
      }
    }
  }
  &-title {
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 26px;
    text-align: left;
    color: $colorN80;
  }

  &-desc {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    margin-top: 8px;
    color: $colorN80;
  }

  &-content {
    padding: 16px;
    background-color: $colorD10;
    margin-top: 24px;
    border-radius: 6px;

    h3 {
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
      text-align: left;
      margin-bottom: 12px;
    }
  }

  .search-field-result-box {
    width: 640px;
    max-height: 340px;
    overflow-y: scroll;
    background-color: $colorN00;
    border-radius: 6px;
    border: 1px solid $colorD40;
    box-shadow: 0px 0px 0px 3px #D3D6DF;
    position: absolute;
    z-index: 2;

    &-item {
      padding: 10px 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 0.5px solid $colorD30;
      color: $colorN80;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      &:hover {
        background-color: $colorM05;
        
        .item-details {
          color: $colorM50;
          font-weight: 600;
        }
      }
    }
    .item-details {
      text-align: left;
    }
  }

  .active-button {
    background-color: $colorM50 !important;
    color: $colorN00 !important;
    cursor: not-allowed;
  }

  .hover-button {
    transition: all 0.2s ease;
  }

  .search-field-result-box-item:hover .hover-button {
    background-color: $colorN80 !important;
    color: $colorN00 !important;
    border-color: $colorN80 !important;
  }

  .search-field-result-box-item:hover .hover-icon {
    color: $colorN00 !important;
  }

  .category-tree-item:hover .hover-button {
    background-color: $colorN80 !important;
    color: $colorN00 !important;
    border-color: $colorN80 !important;
  }

  .category-tree-item:hover .hover-icon {
    color: $colorN00 !important;
  }

  .download-icon {
    transition: color 0.2s ease;
  }

  .download-icon.icon-active{
    color: $colorN00 !important;
  }
}
</style>
